import { getNotificationContainer } from '../../container/notification-module'
import { NotificationService } from '../../modules/notifications/services/NotificationService'
import { NOTIFICATION_SERVICE_KEY } from '../../modules/notifications'
import { getUserContainer } from '../../container/user-module'
import { IUserService, LOGGED_USER_SERVICE_KEY, USER_SERVICE_KEY } from '../../modules/users'
import { ILoggedUserService } from '../../modules/users/services/LoggedUserService'
import { useTranslation } from 'react-i18next'
import React, { useEffect, useState } from 'react'
import { Notification as N } from '../../modules/notifications/models/Notification'
import { Query, QueryParam } from '../../common/api/Query'
import { TransportType } from '../../common/enums/TransportType'
import { forkJoin, Observable } from 'rxjs'
import { User } from '../../modules/users/models/User'
import { Box, CircularProgress, Typography } from '@mui/material'
import { AlertWidget } from './AlertWidget'

const notificationContainer = getNotificationContainer()
const notificationService = notificationContainer.get<NotificationService>(NOTIFICATION_SERVICE_KEY)
const userContainer = getUserContainer()
const userService = userContainer.get<IUserService>(USER_SERVICE_KEY)
const loggedUserService = getUserContainer().get<ILoggedUserService>(LOGGED_USER_SERVICE_KEY)

const notificationsPerPage = 7

type NewsWallProps = {
  id?: string
  selectedDate?: Date
}

export const NewsWall = (props: NewsWallProps) => {
  const { t } = useTranslation()
  const loggedUser = loggedUserService.get()

  const [notifications] = useState<N[]>([])
  const [authors, setAuthors] = useState<Map<string, string>>(new Map())
  const [isLoading, setIsLoading] = useState<boolean>(true) // para observar animacion de recarga hay que poner true
  const [page] = useState<number>(1)
  const [isUserLoading, setIsUserLoading] = useState<boolean>(true)

  useEffect(() => {
    if (isLoading && loggedUser?.id) {
      notificationService
        .getFilteredList(
          new Query({
            pager: { offset: (page - 1) * notificationsPerPage, limit: notificationsPerPage },
            query: [
              new QueryParam<N>('recipientID', loggedUser?.id || ''),
              new QueryParam<N>('transportType', TransportType.App),
            ],
            sort: [{ field: 'createdAt', desc: true }],
          })
        )
        .subscribe((res) => {
          setIsLoading(false)
        })
    }
  }, [isLoading])

  useEffect(() => {
    if (!notifications.length) {
      return
    }
    const authorsTmp = new Map()
    getUsers(notifications.map((n) => n.senderID)).subscribe((res) => {
      res.filter((u) => u).map((u) => authorsTmp.set(u.id, u.firstName))
      setAuthors(authorsTmp)
    })
  }, [notifications])

  useEffect(() => {
    if (!loggedUser?.id) {
      setIsUserLoading(false)
      return
    }

    userService.getByID(loggedUser.id).subscribe(() => {
      setIsUserLoading(false)
    })
  }, [loggedUser])

  const getUsers = (ids: string[]): Observable<User[]> =>
    forkJoin(ids.map((id) => userService.getByID(id))) as unknown as Observable<User[]>

  if (isUserLoading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="400px"
        flexDirection="column"
      >
        <CircularProgress size={60} thickness={4} sx={{ mb: 3, color: 'var(--green-light)' }} />
        <Typography variant="body1" color="text.secondary">
          {t('loading')}
        </Typography>
      </Box>
    )
  }

  // No patient branch: since #3186 the login turns patients away from the web.
  return <AlertWidget />
}
